<template>
  <div>
    <van-nav-bar
        title="拍卖保证金规则"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        style="background: black"
    >
      <template #right >
        <van-icon name="share" size="18" style="color: white;" />
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
import {NavBar,Icon} from 'vant';
export default {
    name: "Auctionrules",
    data(){
        return {
        
        }
    },
    created() {
    },
    methods:{
    
    },
    components:{
      [NavBar.name]:NavBar,[Icon.name]:Icon
    },
    computed:{
    
    }
}
</script>

<style scoped>

</style>
